import { Component, Input, Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { Router } from '@angular/router';
import { ConfigurationService } from './configuration.service';
import { CgpSnackbarService } from '../../cgp-snackbar/cgp-snackbar.service';
import { DataGridTemplate } from '../data-grid.template';

@Component({
    selector: 'grid-config',
    templateUrl: './configuration.component.html',
    styleUrls: ['./configuration.component.scss']
})

@Injectable()
export class ConfigurationComponent {
    /**
     * 
     */
    @Input()
    set template(obj) {
        if (obj.saveUserSettings) {
            this.updateUserSettings(obj);
        }
    }

    /**
     * 
     */
    @Input()
    show: BehaviorSubject<boolean>;
    /**
     * 
     */
    private userSettings: any;
    /**
     * 
     */
    private dataGridColumns: any[];
    /**
     * 
     */
    private dataGridTemplate: DataGridTemplate;
    /**
     * 
     */
    private uidCounter: number = Math.random() * 255 | 0;

    constructor(
        private router: Router,
        private configurationService: ConfigurationService,
        private snackBar: CgpSnackbarService
    ) { }


    /**
     * 
     */
    private getNextUid(): string {
        this.uidCounter = this.uidCounter + 1;
        return `option${this.uidCounter}`;
    }


    /**
     * 
     */
    onSave = () => {
        this.configurationService.saveUserSettings(this.dataGridTemplate.gridState)
            .then(x => {
                this.snackBar.showSnackbar({
                    message: "User Configuration Settings saved.",
                    duration: 2000
                })
            })
    }


    /**
     * 
     */
    isChecked = (dataItem: any, column: any): boolean => {
        return column.field === 'visible' ?
            dataItem.visible :
            dataItem[column.field];
    }

    /**
     * If column field is 'visible': return false
     * Else if 'isFilterSortDisabled' is false or unset: return false
     * Else: return true
     */
    isDisabled = (dataItem: any, column: any): boolean => {
        let disabled: boolean;
        if (column.field !== 'visible') {
            disabled = column.field === 'filterable' && dataItem.isFilterDisabled ||
                column.field === 'sortable' && dataItem.isSortDisabled || !dataItem.visible;
        }
        return disabled;
    }

    /**
     * 
     */
    handleChange = (dataItem: any, column: any): void => {
        dataItem[column.field] = !dataItem[column.field];
        const _columns: any[] = this.configurationService.value;
        const obj = _columns.find(x => x.field === dataItem.field)
        const index = _columns.indexOf(obj);
        _columns[index] = dataItem;
        this.configurationService.next(_columns);
    }

    /**
     * Toggle show variable to false
     */
    closeDialog = (): void => this.show.next(false);


    /**
     * 
     * @param obj 
     */
    private updateUserSettings = (obj: any) => {
        if (obj) {
            this.dataGridTemplate = obj;
            this.dataGridColumns = obj.columns;
            if (!this.userSettings) {
                this.configurationService.getUserSettings()
                    .subscribe(x => {
                        if (x && typeof x !== 'string') {
                            this.userSettings = x;
                            this.setColumns();
                        }
                    })
            } else {
                this.setColumns();
            }
        }
    }


    /**
     * 
     */
    private setGridState(settings: any) {
        if (settings && settings.gridState) {
            const filter = settings.gridState.filter;
            if (filter && filter.length < 1) {
                delete settings.gridState.filter;
            }
            this.dataGridTemplate.gridState = settings.gridState;
            if (settings.gridState.skip === undefined) {
                this.dataGridTemplate.isAll = true;
            }
        }
    }


    /**
     * 
     * @param gridColumn 
     * @param column 
     */
    private updateColumnState(gridColumn: any, column: any) {
        gridColumn.visible = this.getColumnValueByField(column, 'visible');

        if (gridColumn.isSortDisabled) {
            gridColumn.sortable = false;
        } else {
            gridColumn.sortable = this.getColumnValueByField(column, 'sortable');
        }

        if (gridColumn.isFilterDisabled) {
            gridColumn.filterable = false;
        } else {
            gridColumn.filterable = this.getColumnValueByField(column, 'filterable');
        }

        gridColumn.uid = {
            Visible: this.getNextUid(),
            Filterable: this.getNextUid(),
            Sortable: this.getNextUid()
        }
        gridColumn.width = column.width;
        return gridColumn;
    }


    /**
     * 
     * @param dataGridColumns
     */
    private setColumns() {
        const _settings = this.userSettings[this.router.url];
        const columns = _settings && _settings.columns.length == this.dataGridColumns.length ? _settings.columns : this.dataGridColumns;
        this.setGridState(_settings);

        const result: any[] = columns.map((x, i) => {
            let gridColumn = this.dataGridColumns.find(c => c.field === x.field);
            if (!gridColumn) {
                // Search by title
                gridColumn = this.dataGridColumns.find(c => {
                    return c.title.replace(' ', '').toLowerCase() === x.field.toLowerCase();
                });
                if (!gridColumn) return x;
            }
            return this.updateColumnState(gridColumn, x);
        });

        this.configurationService.next(result);
    }


    /**
     * 
     * @param column 
     * @param field 
     */
    private getColumnValueByField(column, field): boolean {
        return column[field] !== null && column[field] !== undefined ? column[field] : true;
    }


    /**
     * 
     */
    gridColumns: any[] = [
        { title: 'Column', field: 'title', type: 'text' },
        { title: 'Visible', field: 'visible', type: 'boolean' },
        { title: 'Filterable', field: 'filterable', type: 'boolean' },
        { title: 'Sortable', field: 'sortable', type: 'boolean' },
    ]

}
